import React, {useEffect} from 'react';
import IconaMenu from './IconaMenu'
import { haPersonalizzazione } from '../funzioni.js';
import stile from './stile.module.css';

function PrenotazioniMenu(props) {    
    const iconaPrenotaPerCorso = require('./prenotapercorso.png');
    const iconaPrenotaPerGiorno = require('./prenotapergiorno.png');
    const iconaLeTuePrenotazioni = require('./elencoprenotazioni.png');
    const iconaElenco = require('./convocati.png');

    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);            
        } 
    }, [props.flagRichiestaBack])

    var oggetto = "corso";
    if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_campo")) oggetto = "campo";

    return (

        <div
            className={stile.homeBackground}
            style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Centra verticalmente (perché la flexDirection è column) tutto il contenuto
            }}
        >

            {!haPersonalizzazione(props.identitaSelezionata, "prenotazioni_iscritti_readonly") &&
                <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                    <IconaMenu
                        callback={() => {
                            if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_certificato_medico") && props.identitaSelezionata.cert_medico_scaduto == 1) {
                                alert("Verifica la validità del certificato medico per poter prenotare");
                                return;
                            }
                            props.callback(props.PAGINECLIENTI.prenotazioni)
                        }}
                        immagine={iconaPrenotaPerCorso}
                        testo={"Prenota\nper "+oggetto}
                    />
                    <IconaMenu
                        callback={() => {
                            if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_certificato_medico") && props.identitaSelezionata.cert_medico_scaduto == 1) {
                                alert("Verifica la validità del certificato medico per poter prenotare");
                                return;
                            }
                            props.callback(props.PAGINECLIENTI.prenotazioniCorsiOggi)
                        }}
                        immagine={iconaPrenotaPerGiorno}
                        testo={"Prenota\nper giorno"}
                    />                
                </div>
            }
            {props.identitaSelezionata.flag_staff && !haPersonalizzazione(props.identitaSelezionata, "prenotazioni_iscritti_readonly") ?
                <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                    <IconaMenu
                        callback={() =>{                            
                            props.callback(props.PAGINECLIENTI.prenotazioniElencoIscritto);
                        }}
                        immagine={iconaLeTuePrenotazioni}
                        testo={"Le tue\nPrenotazioni"}
                    />    
                    <IconaMenu
                        callback={() =>{                            
                            props.callback(props.PAGINECLIENTI.prenotazioniElenco);
                        }}
                        immagine={iconaElenco}
                        testo={"Elenco\nPrenotazioni"}
                    />                        
                </div>
            :
                <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                    <IconaMenu
                        callback={() =>{
                            props.callback(props.PAGINECLIENTI.prenotazioniElencoIscritto);
                        }}
                        immagine={iconaLeTuePrenotazioni}
                        testo={"Le tue\nPrenotazioni"}
                    />    
                </div>
            }
        </div>
    )
}

export default PrenotazioniMenu;
